import { useState } from 'react'

import { User } from '@/types/user'
import UsersTable from './users-table'
import UserDetailModal from './user-details-modal'
import { useUserData } from '../services/use-users-data'
import { useUserFilters } from '../hooks/use-user-filters'
import { useUserPagination } from '../hooks/use-user-pagination'
import { Pagination } from '../../../components/form/shared/pagination'
import { UserFilters } from './user-filter'
import { PageLayout } from '@/layouts'

export default function ListarUsuariosTenant() {
  const [showEditDialog, setShowEditDialog] = useState(false)
  const [selectedUser, setSelectedUser] = useState<User | null>(null)
  const { users } = useUserData()
  const { filteredUsers, searchTerm, setSearchTerm, selectedCargo, setSelectedCargo } = useUserFilters(users)
  const { currentPage, setCurrentPage, totalPages, startIndex, endIndex, paginatedUsers } =
    useUserPagination(filteredUsers)

  const handleUserClick = (user: User) => {
    setSelectedUser(user)
    setShowEditDialog(true)
  }

  const handleCloseDialog = () => {
    setShowEditDialog(false)
  }

  return (
    <PageLayout
      title="Lista de Parceiros"
      description={
        <div className="flex flex-col md:flex-row justify-between gap-4 mb-4">
          <UserFilters
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            selectedCargo={selectedCargo}
            setSelectedCargo={setSelectedCargo}
          />
        </div>
      }
      footer={
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          startIndex={startIndex}
          endIndex={endIndex}
          totalItems={filteredUsers.length}
          onPageChange={setCurrentPage}
        />
      }
    >
      <UsersTable users={paginatedUsers} onClickUser={handleUserClick} />

      <UserDetailModal isOpen={showEditDialog} onClose={handleCloseDialog} user={selectedUser} />
    </PageLayout>
  )
}
